import { createContext, useContext } from 'react';
import type { Me } from './api';
import type { PlexClient, PlexLibrary } from './plex';

export interface AppContext {
  me: Me;
  plex: PlexClient;
  libraries: PlexLibrary[];
  switchProfile: () => void;
}

export const Ctx = createContext<AppContext | null>(null);

export function useApp(): AppContext {
  const c = useContext(Ctx);
  if (!c) throw new Error('useApp buiten de app-context');
  return c;
}
